import Vue from "ninenine-white-label/Vue";
import Vuex from "vuex";

import opportunities from "ninenine-white-label/store/modules/opportunities";
import location from "ninenine-white-label/store/modules/location";
import user from "ninenine-white-label/store/modules/user";
import domains from "ninenine-white-label/store/modules/domains";
import graphql_queries from "ninenine-white-label/store/modules/graphql_queries";
import tests from "ninenine-white-label/store/modules/tests";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    opportunities,
    location,
    user,
    domains,
    graphql_queries,
    tests
  },

  state: {
    source: "carreiras",
    companyId: process.env.VUE_APP_COMPANY_ID,
    bancoDeTalentos: process.env.VUE_APP_BANCO_DE_TALENTOS,

    tkn: `Token token=${process.env.VUE_APP_API_TOKEN}`,

    deviseForm: null,
    deviseLoading: false,

    deviseTrying: {},

    personalDataForm: {},
    educationsForms: [],
    professionalExperiencesForms: [],
    languagesForms: [],
    flag_no_professional_experience: false,
    opportunityQuestionsForm: {},
    indicationForm: {},

    teams: [],

    values: [],

    peoples: [],

    faqItems: [
      {
        title: "",
        content: ""
      },
    ]
  },

  getters: {
  },

  mutations: {
    DEVISE_FORM(state, payload) {
      state.deviseForm = payload;
    },

    DEVISE_LOADING(state, payload) {
      state.deviseLoading = payload;
    },

    DEVISE_TRYING(state, payload) {
      state.deviseTrying = payload == null ? {} : payload;
    },

    PERSONAL_DATA_FORM(state, payload) {
      state.personalDataForm = payload;
    },

    EDUCATIONS_FORMS(state, payload) {
      if (!payload) {
        state.educationsForms = [];
      } else {
        if (state.educationsForms.find((form) => form._uid == payload._uid)) {
          state.educationsForms[
            state.educationsForms.findIndex((form) => form._uid == payload._uid)
          ] = payload;
        } else {
          state.educationsForms.push(payload);
        }
      }
    },

    PROFESSIONAL_EXPERIENCES_FORMS(state, payload) {
      if (!payload) {
        state.professionalExperiencesForms = [];
      } else {
        if (
          state.professionalExperiencesForms.find(
            (form) => form._uid == payload._uid
          )
        ) {
          state.professionalExperiencesForms[
            state.professionalExperiencesForms.findIndex(
              (form) => form._uid == payload._uid
            )
          ] = payload;
        } else {
          state.professionalExperiencesForms.push(payload);
        }
      }
    },

    LANGUAGES_FORMS(state, payload) {
      if (!payload) {
        state.languagesForms = [];
      } else {
        if (state.languagesForms.find((form) => form._uid == payload._uid)) {
          state.languagesForms[
            state.languagesForms.findIndex((form) => form._uid == payload._uid)
          ] = payload;
        } else {
          state.languagesForms.push(payload);
        }
      }
    },

    SET_FLAG_PROFESSIONAL_EXPERIENCE(state, payload) {
      state.flag_no_professional_experience = payload;
    },

    OPPORTUNITY_QUESTIONS_FORM(state, payload) {
      state.opportunityQuestionsForm = payload;
      localStorage.setItem("opportunity_questions", JSON.stringify(payload));
    },

    INDICATION_FORM(state, payload) {
      state.indicationForm = payload;
      localStorage.setItem("indication_form", JSON.stringify(payload));
    }
  }
});
